module.exports = __webpack_public_path__ + "img/v_p2.4a4c6d5a.svg";